import { UpdateCartItemMutation } from '@deity/falcon-shop-data';

export class UpdateCartItemMutationExt extends UpdateCartItemMutation {
  static defaultProps = {
    ...super.defaultProps,
    refetchQueries: ['MiniCart', 'Cart', 'FreeShipping', 'InitPaypalExpress']
  };
}
